export interface Country {
    value: string;
    viewValue_en: string;
    viewValue_fr: string;
    viewValue_sp: string;
}
export const countries: Country[] = [
    { value: 'US', viewValue_en: 'United States', viewValue_sp: 'United States', viewValue_fr: 'United States' },
    { value: 'CA', viewValue_en: 'Canada', viewValue_sp: 'Canada', viewValue_fr: 'Canada' },
    { value: 'MX', viewValue_en: 'Mexico', viewValue_sp: 'Mexico', viewValue_fr: 'Mexico' }
];
